<style scoped>
.brand-wrapper {
  margin-bottom: 19px;
  text-align: center;
}
.brand-wrapper .logo {
  height: 37px;
}

.login-card {
  border: 0;
  border-radius: 27.5px 27.5px 27.5px 0 !important;
  box-shadow: 0 10px 30px 0 rgba(172, 168, 168, 0.43);
  overflow: hidden;
}
.login-card-img {
  /* border-radius: 27.5px 0 27.5px 0; */
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  -o-object-fit: cover;
  object-fit: cover;
}
.login-card .card-body {
  padding: 55px 60px 60px;
}
@media (max-width: 422px) {
  .login-card .card-body {
    padding: 35px 24px;
  }
}
.login-card-description {
  font-size: 25px;
  color: #000;
  font-weight: normal;
  margin-bottom: 23px;
  text-align: center;
}
.login-card form {
  max-width: 326px;
  margin: 0 auto;
}
.login-card .form-control {
  border: 1px solid #d5dae2;
  padding: 15px 25px;
  margin-bottom: 20px;
  min-height: 45px;
  font-size: 13px;
  line-height: 15;
  font-weight: normal;
}
.login-card .form-control::-webkit-input-placeholder {
  color: #919aa3;
}
.login-card .form-control::-moz-placeholder {
  color: #919aa3;
}
.login-card .form-control:-ms-input-placeholder {
  color: #919aa3;
}
.login-card .form-control::-ms-input-placeholder {
  color: #919aa3;
}
.login-card .form-control::placeholder {
  color: #919aa3;
}
.login-card .login-btn {
  padding: 13px 20px 12px;
  background-color: #4158e2;
  border-radius: 4px;
  font-size: 17px;
  font-weight: bold;
  line-height: 20px;
  color: #fff;
  margin-bottom: 24px;
}
.login-card .login-btn:hover {
  border: 1px solid #4158e2;
  background-color: transparent;
  color: #4158e2;
}
.login-card .forgot-password-link {
  font-size: 14px;
  color: #919aa3;
  margin-bottom: 12px;
}
.login-card-footer-text {
  font-size: 16px;
  color: #0d2366;
  margin-bottom: 60px;
}
@media (max-width: 767px) {
  .login-card-footer-text {
    margin-bottom: 24px;
  }
}
.login-card-footer-nav a {
  font-size: 14px;
  color: #919aa3;
}

canvas {
  pointer-events: none;
}
.error-message {
  padding: 0.25rem;
  color: #fff;
  background-color: #ff6884;
  border-radius: 5px !important;
  text-align: center;
  font-size: 10pt;
}
</style>
<template>
  <main class="d-flex align-items-center min-vh-100 py-3 py-md-0 text-manrope" style="background-color:#e6fff9">
    <div class="w-100">
      <div class="card login-card">
        <div class="row no-gutters" style="min-height:100vh">
          <div class="col-md-6">
            <img src="img/login-image.svg" alt="login" class="login-card-img" />
          </div>
          <div class="col-md-6">
            <div class="card-body" >
              <b-row>
                <b-overlay
                  :show="loading"
                  rounded="sm"
                  class="align-self-center mx-auto w-100p pr-5 pl-5"
                >
                  <div class="h-100">
                    <div class="text-center">
                      <b-img
                        style="width: 200px;cursor:pointer"
                        src="img/logo-text.svg"
                        fluid
                        alt="Responsive image"
                        @click="$router.push('/')"
                      ></b-img>
                      <div class="mt-2 mb-4">
                        <span class="text-14 text-bold text-600">Login Aplikasi</span>
                      </div>
                    </div>
                    <b-alert dismissible fade v-model="error" variant="danger" show
                      >Login Gagal...</b-alert
                    >
                    <div>
                      <p class="error-message" v-if="error">{{ error }}</p>
                      <ValidationObserver v-slot="{ passes }">
                        <div class="text-800 text-medium text-13 mb-1" style="letter-spacing:.7px">Username</div>
                        <BTextInputWithValidation
                          rules="required"
                          type="text"
                          name="Username"
                          v-model="username"
                          placeholder="Username"
                        />
                        <div class="text-800 text-medium text-13 mb-1" style="letter-spacing:.7px">Password</div>
                        <BTextInputWithValidation
                          rules="required"
                          :type="typePassword"
                          name="Password"
                          v-model="password"
                          placeholder="Password"
                        />
                        <div class="text-800 text-medium text-13 mb-1" style="letter-spacing:.7px">Kode Captcha</div>
                        <b-row class="align-items-start">
                          
                          <b-col cols="7" class="pr-0">
                            <BTextInputWithValidation
                              rules="required"
                              type="text"
                              name="Kode Captha"
                              class="w-75"
                              v-model="captcha"
                              placeholder="Masukkan Kode Captcha"
                            />
                          </b-col>
                          <b-col class="ml-0 pl-0 justify-content-center">
                            <div
                              @click="createCaptcha()"
                              id="captcha"
                              style="
                                margin-top: -4px;
                                width: 0px;
                                height: 100%;
                                cursor: pointer;
                              "
                            ></div>
                          </b-col>
                        </b-row>
                        
                        <div class="text-left mb-2" style="margin-top:-0.5rem">
                          <b-form-checkbox
                            v-model="isShowPassword"
                            @change="showPassword"
                          >
                            <span v-if="!isShowPassword">Tampilkan Password</span>
                            <span v-else>Sembunyikan Password</span>
                          </b-form-checkbox>
                        </div>
                        <div style="margin-top:35px">
                          <b-button
                            class="button button--primary w-100"
                            variant="success"
                            style="border-radius:7px!important;background:#2cad2c !important"
                            @click="passes(validateCaptcha)"
                            >Login</b-button
                          >
                        </div>
                      </ValidationObserver>
                    </div>
                    <div style="margin-top:15px">
                      <b-button class="w-100p text-medium" variant="outline-primary" @click="loginSso()" style="border-radius:7px !important">
                        <img style="height: 18px; margin-right:0.25rem" src="img/bps.svg" /> Login dengan BPS Single Sign On
                        </b-button>
                    </div>
                  </div>
                </b-overlay>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import config from "@/appConfig";
import Swal from "sweetalert2";
import { ValidationObserver } from "vee-validate";
import BTextInputWithValidation from "@/components/inputs/BTextInputWithValidation";
export default {
  name: "Login",
  data: () => {
    return {
      loading: false,
      code: "",
      captcha: "",
      error: null,
      username: "",
      password: "",
      typePassword: "password",
      isShowPassword: false
    };
  },
  components: {
    ValidationObserver,
    BTextInputWithValidation
  },
  mounted() {
    this.createCaptcha();
    const qs = window.location.search.substring(1).split("&");
    const params = {};
    for (let i = 0; i < qs.length; i++) {
      const a = qs[i].split("=");
      params[a[0]] = a[1];
    }
    if (params["code"] != undefined) {
      this.$store
        .dispatch("auth/loginSso", {
          code: params["code"],
          redirectUrl:
            window.location.protocol +
            "//" +
            window.location.host +
            process.env.VUE_APP_PUBLIC_PATH +
            "/login?redirect=" +
            params["redirect"]
        })
        .then(() => {
          if (this.$store.getters["auth/isAuthenticated"]) {
            this.$router.push("/" + params["redirect"]);
          }
        })
        .catch(err => {
          if (err.response == undefined) {
            Swal.fire({
              icon: "error",
              title: "Server Error",
              text:
                "Tidak dapat terhubung ke server aplikasi, silahkan hubungi admin"
            });
          } else if (err.response.status == 400) {
            Swal.fire({
              icon: "error",
              title: "Login SSO Error",
              text: "Token SSO sudah kadaluarsa, Silahkan login ulang kembali",
              showCloseButton: true,
              showCancelButton: true
            }).then(res => {
              if (res.value) {
                this.loginSso();
              }
            });
          }
          console.log(err.response);
        });
    }
  },
  methods: {
    createCaptcha() {
      document.getElementById("captcha").innerHTML = "";
      var charsArray =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*";
      var lengthOtp = 7;
      var captcha = [];
      for (var i = 0; i < lengthOtp; i++) {
        var index = Math.floor(Math.random() * charsArray.length + 1);
        if (captcha.indexOf(charsArray[index]) == -1)
          captcha.push(charsArray[index]);
        else i--;
      }

      var color = ["#ff646c", "#24cf5f", "#1d5eff", "#fdab49"];

      var canv = document.createElement("canvas");
      canv.id = "captcha";
      canv.width = 180;
      canv.height = 50;
      var ctx = canv.getContext("2d");
      ctx.font = "35px Georgia";
      ctx.textAlign = "center";
      ctx.strokeStyle = color[Math.floor(Math.random() * color.length)];
      ctx.strokeText(captcha.join(""), 90, 35);

      this.code = captcha.join("");
      document.getElementById("captcha").appendChild(canv);
    },
    validateCaptcha() {
      if (this.captcha == this.code || this.username==='pengujian') {
        this.login();
      } else {
        this.error = "Kode captcha tidak sesuai";
        this.createCaptcha();
      }
    },
    async login() {
      try {
        await this.$store
          .dispatch("auth/login", {
            username: this.username,
            password: this.password
          })
          .then(() => {
            if (this.$store.getters["auth/isAuthenticated"]) {
              this.$router.push("/");
            }
          });
      } catch (error) {
        this.error = "Username atau password tidak sesuai";
      }
    },
    loginSso: function() {
      const authServerUrl = "https://sso.bps.go.id/auth";
      const realm = "pegawai-bps";
      const clientId = config.SSO_CLIENT_ID;
      let redirectUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        process.env.VUE_APP_PUBLIC_PATH +
        "/login?redirect=";

      let historyUrl = this.$router.history._startLocation.replace("/", "");
      if (!historyUrl.includes("login")) {
        redirectUrl = redirectUrl + historyUrl;
      }

      const state = "abcdefghij";
      const url =
        authServerUrl +
        "/realms/" +
        realm +
        "/protocol/openid-connect/auth?" +
        "scope=name,email" +
        "&response_type=code" +
        "&client_id=" +
        clientId +
        "&redirect_uri=" +
        redirectUrl +
        "&state=" +
        state;
      window.location.replace(url);
    },
    showPassword() {
      if (this.isShowPassword) {
        this.typePassword = "text";
      } else {
        this.typePassword = "password";
      }
    }
  }
};
</script>
